import { StyleSheet, type TextStyle } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const posCheckoutCustomerStyleDefs = {
  checkoutCustomerPicker: {
    gap: spacing.sm,
    marginTop: 2,
  },

  checkoutCustomerSearch: {
    minHeight: 44,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    paddingHorizontal: 14,
    paddingVertical: 10,
    fontSize: 15,
    fontWeight: '500' as const,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },

  checkoutCustomerPickerMain: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
  },

  checkoutCustomerPickerBalance: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    fontWeight: '700' as const,
    fontFamily: ticketFonts.mono,
  },

  checkoutCustomerPagination: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: spacing.xs,
    paddingTop: spacing.xs,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
  },

  checkoutCustomerPaginationButton: {
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.xs,
    borderRadius: 10,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },

  checkoutCustomerPaginationButtonDisabled: {
    opacity: 0.4,
  },

  checkoutCustomerPaginationButtonText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600' as const,
    fontFamily: ticketFonts.sans,
  },

  checkoutCustomerPaginationButtonTextDisabled: {
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },

  checkoutCustomerPaginationInfo: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
} as const;
